import React from "react";
import _ from "underscore";
import { withStyles } from "material-ui/styles";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Button } from "material-ui";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import { convertLocaleKeyToName } from "utils/formatter";
import QuestionData from "assets/data/QuestionData";
import QuestionAnswerPanel from "components/QuestionAnswerPanel";

const styles = theme => {
  return {
    dialogContent: {
      width: 1100
    },
    errorMessage: {
      fontSize: ".9rem",
      margin: "0 20px 10px"
    },
    paperDesc: {
      color: "#9699a2",
      fontSize: "1rem",
      fontWeight: 300,
      marginBottom: 5
    },
    container: {
      display: "flex",
      flexWrap: "wrap"
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 120
    },
    qLabel: {
      marginLeft: 70,
      fontSize: "1.7rem"
    },
    questionArea: {
      padding: "10px 0 20px",
      backgroundColor: theme.palette.answer.backgroundColor,
      borderTop: `2px solid ${theme.palette.answer.borderColor}`,
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    }
  };
};

class PreviewModal extends React.Component {
  naviStyle(localeNo) {
    return this.props.previewModal.localeNo === localeNo
      ? { color: "#fff", backgroundColor: "#26a69a" }
      : { color: "#333", backgroundColor: "transparent" };
  }

  render() {
    const { classes, previewModal, baseInfo } = this.props;
    const {
      open,
      selectedItemId,
      items,
      localeNo,
      additionMode
    } = previewModal;
    let item = null;
    let itemIndex = 0;
    let choices = QuestionData.CHOICES.ja.answers;
    if (localeNo) {
      item =
        items[localeNo] &&
        items[localeNo].filter(c => c.id - selectedItemId === 0)[0];
      itemIndex = items[localeNo] ? items[localeNo].indexOf(item) : 0;
      choices =
        (item && item.choices) || QuestionData.CHOICES[localeNo].answers;
    }

    return (
      <Dialog open={open}>
        <DialogTitle id="form-dialog-title">プレビュー</DialogTitle>

        <DialogContent className={classes.dialogContent} style={{ padding: 0 }}>
          <div>
            {/* 言語タブ */}
            <div>
              <BottomNavigation
                style={{ justifyContent: "left" }}
                value={previewModal.localeNo}
                onChange={this.props.changeLocale}
                showLabels
              >
                {_.map(baseInfo.useLocales, locale => (
                  <BottomNavigationAction
                    key={locale}
                    style={this.naviStyle(locale)}
                    value={locale}
                    label={convertLocaleKeyToName(locale)}
                  />
                ))}
              </BottomNavigation>
            </div>

            <div>
              <div className={classes.questionArea}>
                <div className={classes.qLabel}>
                  Q{additionMode ? itemIndex + 64 : itemIndex + 1}
                </div>

                <QuestionAnswerPanel
                  text={item && item.content}
                  choices={choices || []}
                />
              </div>
            </div>
            <div>
              <Button
                disabled={itemIndex === 0}
                size="medium"
                className={classes.button}
                onClick={this.props.handlePrev}
              >
                前へ
              </Button>
              <Button
                disabled={
                  items[localeNo] && items[localeNo].length - 1 === itemIndex
                }
                size="medium"
                className={classes.button}
                style={{ float: "right" }}
                onClick={this.props.handleNext}
              >
                次へ
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button raised onClick={this.props.handleClose}>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(PreviewModal);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/PreviewModal.jsx